import * as css from './crowdSearch.css';
import PopUpWithHeader from '../../../component/newPopup/popUpWithHeader/PopUpWithHeader';
import {crowdSearchImage} from '../../../assets/symbols/images/crowdSearchimage';
import {search} from '../../../assets/symbols/symbols/Symbols.css';
import Btn from '../../../component/button/btn/Btn';
import {useCallback, useMemo, useRef, useState} from 'react';
import {searchCrowds} from '../../../redux/crowds/crowdsActions';
import {useSelector} from 'react-redux';
import {XHR_SUCCESS_STATE} from '../../../assets/constants/constants';
import setGlobalState from '../../../redux/setGlobalState';
import {NoResults, SearchResult, StartsSearch} from './searchPopupComponents';
import {useTranslation} from 'react-i18next';

function CrowdSearch({show}){
    const {t} = useTranslation('crowd');
    const [searchText, setSearchText]=useState('');
    const {searchResults=[], searchCrowdsXHR} = useSelector((state: any) => (state.crowds));
    const [isEndOfResults, setIsEndOfResults]=useState(false);

    const onClose=()=>{
        resetSearch();
        show.close();
    };

    const resetSearch = ()=>{
        setSearchText('');
        setGlobalState('crowds.searchCrowdsXHR', null);
        setGlobalState('crowds.searchResults', []);
        setIsEndOfResults(false);
    };
    const handleDelayedSearch = useCallback((value) => {
        if(value){
            setSearchText(value);
            searchCrowds(value).then(isEnd=>setIsEndOfResults(isEnd));
        } else {
            resetSearch();
        }
        if(searchInputRef.current?.timeout) {
            clearTimeout(searchInputRef.current.timeout);
        }
    }, []);

    const onSearch = (e) => {
        const value = e.target.value;
        if(searchInputRef.current?.timeout) {
            clearTimeout(searchInputRef.current.timeout);
        }
        searchInputRef.current.timeout = setTimeout(() => {
            handleDelayedSearch(value);
        }, 700);
    };

    const loadMore=()=>{
        if(!searchText || isEndOfResults) return;
        const lastIndex=searchResults.length-1;
        searchCrowds(searchText, 10, lastIndex, searchResults[lastIndex]?.members.length).then(isEnd=>setIsEndOfResults(isEnd));
    };
    const membersCount = useMemo(()=>searchResults.reduce((acc, table) => acc+=table.members.length,0), [searchResults]);
    const searchInputRef = useRef(null);
    const setFocusOnInput = ()=>{
        if(searchInputRef.current){
            searchInputRef.current.focus();
        }
    };
    return (
        <css.popupWrapper>
            <PopUpWithHeader show={{...show, close: onClose}} image={crowdSearchImage} title={t('searchCrowds')} dataCyName={'crowdSearch'} topChildren={undefined}>
                <css.container>
                    <css.searchInput $icon={search}>
                        <input ref={searchInputRef} onChange={onSearch} placeholder={t('searchPlaceholder')} name={''}/>
                    </css.searchInput>
                    <css.resultContent>
                        {searchCrowdsXHR === XHR_SUCCESS_STATE && !membersCount? <NoResults />
                            : searchCrowdsXHR === null? <StartsSearch setFocus={setFocusOnInput} />
                                : <>
                                    <SearchResult  loadMore={loadMore} searchText={searchText} close={onClose}/>
                                    {isEndOfResults && searchCrowdsXHR===XHR_SUCCESS_STATE &&<>{t('endOfResults')}</>}
                                </> }
                    </css.resultContent>
                    <css.footer><Btn style='height: 34px; width: 124px;' onClick={onClose}>{t('close')}</Btn></css.footer>
                </css.container>
            </PopUpWithHeader>
        </css.popupWrapper>
    );

}
export default CrowdSearch;
